export const money = (n, currency = "AED") =>
  new Intl.NumberFormat("en", {
    style: "currency",
    currency: currency || "AED",
    maximumFractionDigits: currency === "OMR" || currency === "BHD" || currency === "KWD" ? 3 : 2,
  }).format(Number(n) || 0);

export const aed = (n) => money(n, "AED");

export const num = (n) =>
  new Intl.NumberFormat("en-AE", { maximumFractionDigits: 2 }).format(
    Number(n) || 0,
  );

export const pct = (n) => `${Number(n) || 0}%`;
